<div class="license-suspended-page-container container">
  <p>{{ 'LICENSE_SUSPENDED_MESSAGE' | translate:{ date: wizard.model.license.suspendedDate | insightsDate } }}</p>
  <p>
    {{ 'CONTACT_BILLING_MESSAGE' | translate }}
    <a class="color-help" href="mailto:billing@retailstat.com?subject=MTN%20Insights%20License%20Renewal" target="_blank">
      billing&#64;retailstat.com
    </a>
    {{ 'CONTACT_BILLING_END' | translate }}
  </p>
</div>
